import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BackOrderExpediteEmailRequest } from "@preferredMedical/Models/CustomForms/BackOrderRequestExpedite/BackOrderExpediteEmailRequest";
import { BillPaymentFormRequest } from "@preferredMedical/Models/CustomForms/BillPayment/BillPaymentFormRequest";
import { BiomedicalDivisionEmailRequest } from "@preferredMedical/Models/CustomForms/BiomedicalDivision/BiomedicalDivisionEmailRequest";
import { PumpReturnEmailRequest } from "@preferredMedical/Models/CustomForms/PumpReturn/PumpReturnEmailRequest";
import { TradeshowFormRequest } from "@preferredMedical/Models/CustomForms/Tradeshow/TradeshowFormRequest";
import { EmailSubscriptionSignUpRequest } from "@preferredMedical/Models/Header/EmailSubscriptionSignUpRequest";

const tradeshowUrl = "api/v1/Tradeshow";
const pumpReturnEmailUrl = "api/v1/PumpReturn";
const backOrderRequestExpediteEmailUrl = "api/v1/OrderHistory";
const emailSubscriptionSignUpUrl = "api/v1/Email/SubscriptionSignUp";
const biomedicalDivisionUrl = "api/v1/BiomedicalDivision";
const billPaymentUrl = "api/v1/InvoicePayment";
const newsletterRegistrationUrl = "api/v1/NewsletterRegistration";

export function sendTradeshowForm(model: TradeshowFormRequest) {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", tradeshowUrl, false);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.send(JSON.stringify(model));
}

export async function sendBackOrderExpediteEmail(model: BackOrderExpediteEmailRequest) : Promise<ServiceResult<any>> {
    try {
        const response = await post(backOrderRequestExpediteEmailUrl, model);
        return {
            result: response,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: "Someting went wrong when submitting the form.",
        };
    }
}

export async function sendPumpReturnEmail(model: PumpReturnEmailRequest) {
    await post(pumpReturnEmailUrl, model);
}

export async function sendEmailSubscriptionSignUp(model: EmailSubscriptionSignUpRequest) {
    await post(emailSubscriptionSignUpUrl, model);
}

export function sendBiomedicalDivisionEmail(model: BiomedicalDivisionEmailRequest) {
    return post(biomedicalDivisionUrl, model);
}

export function sendBillPayment(model: BillPaymentFormRequest) {
    return post(billPaymentUrl, model);
}

export function sendNewsletterRegistrationEmail(model: string) {
    return post(newsletterRegistrationUrl, model);
}
